import styled from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const StyledTabs = styled.div.attrs({
	className: 'fuse-tabs',
})`
	overflow-x: auto;
	scrollbar-width: none;
`;

const StyledTab = styled.button.attrs({
	className: 'fuse-tabs__tab',
	'data-testid': 'fuse-tabs-tab-test-id',
})`
	position: relative;
	width: max-content;
	padding: var(--spacing-global-space4) var(--spacing-global-space5);
	outline: 0;
	border: 0;
	background: var(--color-global-grey200);
	scroll-snap-align: start;
	cursor: pointer;

	&:after {
		display: block;
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		border-bottom: var(--border-width-s) solid var(--color-global-grey400);
	}

	&:active,
	&.active {
		background: var(--color-global-grey100);

		.fuse-tabs__tab-label {
			font-weight: var(--font-weight-heading);
		}

		&:after {
			border-bottom: var(--border-width-s) solid var(--color-brand-mid);
		}
	}

	@media not all and (pointer: coarse) {
		&:hover {
			background: var(--color-global-grey300);

			.fuse-tabs__tab-label {
				font-weight: var(--font-weight-heading);
				color: var(--color-brand-dark);
			}
		}
	}

	&:focus {
		background: var(--color-global-grey300);
		outline: var(--border-width-s) solid var(--color-functional-focus);
		outline-offset: -2px;

		&&:after {
			border-bottom: 0;
		}

		.fuse-tabs__tab-label {
			font-weight: var(--font-weight-heading);
			color: var(--color-brand-dark);
		}
	}
`;

const StyledTabLabel = styled(TypographyComponent).attrs({
	className: 'fuse-tabs__tab-label',
	'data-testid': 'fuse-tabs-tab-label-test-id',
})`
	margin-bottom: 0;
	pointer-events: none;
	width: max-content;
	text-align: center;

	&:before {
		display: block;
		content: attr(title);
		font-weight: var(--font-weight-heading);
		height: 0;
		overflow: hidden;
		visibility: hidden;
	}
`;

const StyledTabListContainer = styled.div.attrs({
	className: 'fuse-tabs__tab-list-container',
	'data-testid': 'fuse-tabs-tab-list-container-test-id',
})`
	position: relative;
`;

const StyledTabList = styled.div.attrs({
	className: 'fuse-tabs__tab-list',
	'data-testid': 'fuse-tabs-tab-list-test-id',
})`
	display: flex;
	position: relative;
	gap: var(--spacing-global-space3);
	margin-left: var(--spacing-global-space5);
	margin-bottom: var(--spacing-global-space6);
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	box-shadow: inset 0px -2px 0px var(--color-global-grey400);

	@media only screen and (min-width: ${gridConfig.m.minWidth}) {
		margin-left: var(--spacing-global-space6);
	}

	@media only screen and (min-width: ${gridConfig.l.minWidth}) {
		margin-left: 0;
		margin-right: 0;
		margin-bottom: var(--spacing-global-space7);
		scroll-snap-type: none;
	}
`;

const StyledTabPanelContainer = styled.div.attrs({
	className: 'fuse-tabs__tab-panel-container',
	'data-testid': 'fuse-tabs-tab-panel-container-test-id',
})``;

const StyledTabPanel = styled.div.attrs({
	className: 'fuse-tabs__tab-panel',
	'data-testid': 'fuse-tabs-tab-panel-test-id',
})`
	width: 100%;

	&:focus {
		outline: 0;
	}
`;

export {
	StyledTabs,
	StyledTab,
	StyledTabLabel,
	StyledTabListContainer,
	StyledTabList,
	StyledTabPanelContainer,
	StyledTabPanel,
};
